import { Box, Card, Typography } from '@mui/material';
import { FC } from 'react';
import { useSignInCardStyles } from './useSignInCardStyles';

import {
  Login,

} from '@mui/icons-material';

type Props = {
  time: string;
  signedIn: boolean;
  globalSignIn: boolean;
};

export const SignInCardContent: FC<Props> = ({
  time,signedIn,globalSignIn
}) => {
  const classes = useSignInCardStyles();
  if(signedIn || globalSignIn){
  return (
    <>
       <Box sx={classes.headingSignedIn} px={2} py={1}>
        <Box textAlign="center" mr={3}>
          <Login fontSize="large" />
        </Box>
        <Box sx={classes.col}>
          <Typography variant="h5">Sign in</Typography>
          <Typography variant="subtitle2">{time}</Typography>
        </Box>
      </Box>
    </>
  );
  }
  else{
    return (
      <>
         <Box sx={classes.headingNotSignedIn} px={2} py={1}>
          <Box textAlign="center" mr={3}>
            <Login fontSize="large" />
          </Box>
          <Box sx={classes.col}>
            <Typography variant="h5">Sign in</Typography>
            <Typography variant="subtitle2">{time}</Typography>
          </Box>
        </Box>
      </>
    );
  }
};

export const SignInCard: FC = ({ children }) => {
  const classes = useSignInCardStyles();
  return <Card sx={classes.root}>{children}</Card>;
};